import { Component } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Raven from 'raven-js';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Flex } from 'foundations-components/components/Flex';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LoaderPage extends Component {
  constructor(props) {
    super(props);
    this.ifErrorLogOnce = () => {
      const {
        error
      } = this.props;
      if (error && !this.loggedError) {
        this.loggedError = true;
        Raven.captureMessage(`Error loading route`, {
          extra: Object.assign({}, error)
        });
      }
    };
    this.loggedError = false;
  }
  componentDidMount() {
    this.ifErrorLogOnce();
  }
  componentDidUpdate() {
    this.ifErrorLogOnce();
  }
  render() {
    const {
      error
    } = this.props;
    if (error) {
      return /*#__PURE__*/_jsx(ErrorMessage, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "loading.error_jsx",
          elements: {
            Button
          },
          options: {
            onClick: () => {
              window.location.reload();
            },
            use: 'link'
          }
        })
      });
    }
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignSelf: "center",
      position: "absolute",
      children: /*#__PURE__*/_jsx(LoadingOverlay, {
        contextual: true
      })
    });
  }
}